import { useState } from 'react';

import Layout from '../../components/Layouts/Layout';
import TabBar from '../../components/Navbars/TabBar';
import CoursesOrder from './CoursesOrder';
import LogosManager from './LogosManager';

const tabs = [
  { label: 'Gestión de Logotipos', component: <LogosManager /> },
  { label: 'Orden de Cursos', component: <CoursesOrder /> },
];

const Configuration = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <Layout marginContainer={false}>
      <TabBar
        items={tabs.map((tab) => ({ label: tab.label }))}
        onSelectionChange={(index) => setSelectedIndex(index)}
      />
      {tabs[selectedIndex].component}
    </Layout>
  );
};

export default Configuration;
